module.exports = __webpack_public_path__ + "img/0x748ad98b14c814b28812eb42ad219c8672909879.bda209da.png";